
import React, { useState, useContext, useEffect} from 'react';
import Modal from './Modal';
import Button from '../ui/Button';
import FileUpload from '../ui/FileUpload';
import RichTextEditor from '../ui/RichTextEditor';
import { getStorage, ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { message } from 'antd';
// import { string } from 'yup';
import { NecttosContext } from '../../../context/NecttosContext';
import { getAxiosTokenInstance } from '../../../utils/axiosInstance';

interface AssignmentModalProps {
  isOpen: boolean;
  onClose: () => void;
//   onSubmit: (data: AssignmentData) => void;
  modules: any[],
  subjectId: string
  students: string[];
}

interface AssignmentData {
  title: string;
  description: string;
  attachments: {name: string, url: string};
  submissionTypes: string[];
  maxFileSize: number;
  dueDate: string;
  cutoffDate: string;
  maxMarks: number;
  moduleId: string;
  subjectId: string;
  category: string;
  groups: any[];
  individualIds: any[]

}

const DemoAssignmentModal: React.FC<AssignmentModalProps> = ({ isOpen, onClose,subjectId, modules, students}) => {
const [groupName, setGroupName] = useState([]);
const [moduleId, setModuleId] = useState('');
const [studentId, setStudents] = useState<any[]>([]);
useEffect(() => {
  const loadData = async() => {
    const instance = await getAxiosTokenInstance()
try{
    // getting group names of the subject , college, and moduleId
   const resp = await instance.get('/college/lms/groupAssignments/getGroupNames', {
    params: {
      collegeId,
      subjectId,
      moduleId,
    }

 
   })
   if(resp?.data) {
    console.log(resp.data.data)
    setGroupName(resp.data.data);
   }
   
  }catch(err) {
  console.log(err)
  }
  }
  const fetchStudentNames = async () => {
      try {
        const instance = await getAxiosTokenInstance();
        const resp = await instance.post('/college/lms/all/getStudentNames', { ids: students });
        if (resp?.data?.data) setStudents(resp.data.data);
      } catch (err) {
        console.error('Failed to fetch student names:', err);
      }
    };

loadData()
fetchStudentNames()
},[moduleId, subjectId])

  const [formData, setFormData] = useState<AssignmentData>({
    title: '',
    description: '',
    attachments: {name:'', url: ''},
    submissionTypes: [],
    maxFileSize: 10,
    dueDate: '',
    cutoffDate: '',
    maxMarks: 100,
    moduleId: '',
    subjectId: 'subject1', // change this into subjedtId itself,
    category: '',
    groups: [],
    individualIds: [],
  });
  const { collegeId } = useContext(NecttosContext);
  const [errors, setErrors] = useState<{ [key: string]: string }>({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [state, setState] = useState()
  const [imagePreview, setImagePreview] = useState<string | undefined>(undefined);
  const [isUploading, setIsUploading] = useState<boolean>(false);

  const submissionTypeOptions = [
    { id: 'files', label: 'Files', icon: '📁' },
    { id: 'text', label: 'Text Input', icon: '📝' },
    { id: 'images', label: 'Images', icon: '🖼' },
    { id: 'videos', label: 'Videos', icon: '🎥' }
  ];

const mockStudents = [
  { id: 'STU-001', name: 'Alice Johnson' },
  { id: 'STU-002', name: 'Bob Smith' },
  { id: 'STU-003', name: 'Charlie Brown' },
  { id: 'STU-004', name: 'Daisy Ridley' },
];


  const validateForm = (): boolean => {
    const newErrors: { [key: string]: string } = {};

    if (!formData.title.trim()) {
      newErrors.title = 'Title is required';
    }

    if (!formData.description.trim()) {
      newErrors.description = 'Description is required';
    }

    if (!formData.dueDate) {
      newErrors.dueDate = 'Due date is required';
    }

    if (!formData.cutoffDate) {
      newErrors.cutoffDate = 'Cut-off date is required';
    }

    if (formData.dueDate && formData.cutoffDate && new Date(formData.cutoffDate) < new Date(formData.dueDate)) {
      newErrors.cutoffDate = 'Cut-off date must be after due date';
    }

    if (formData.maxMarks <= 0) {
      newErrors.maxMarks = 'Maximum marks must be greater than 0';
    }

    if (formData.submissionTypes.length === 0) {
      newErrors.submissionTypes = 'At least one submission type must be selected';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e: React.FormEvent) => {
    const instance = await getAxiosTokenInstance()
    e.preventDefault();
    
    if (!validateForm()) {
      return;
    }

    setIsSubmitting(true);
    
    try {
      console.log(formData);
      // Simulate API call
      const resp = await instance.post(`/college/lms/assignment/createAssignment`, {...formData, collegeId: 'college1'}); // change this to collegeId itself
      if(resp?.data) {
         console.log(resp.data.message)
        message.success('Assignment created')
       
      }
      handleReset();
      onClose();
    } catch (error) {
      console.error('Error creating assignment:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleReset = () => {
    setFormData({
      title: '',
      description: '',
      attachments: {name: '', url:''},
      submissionTypes: [],
      maxFileSize: 10,
      dueDate: '',
      cutoffDate: '',
      maxMarks: 100,
      moduleId: '',
      subjectId: subjectId,
      groups: [],
      individualIds: [],
      category: ''
    });
    setErrors({});
  };

  const handleSubmissionTypeChange = (typeId: string) => {
    setFormData(prev => ({
      ...prev,
      submissionTypes: prev.submissionTypes.includes(typeId)
        ? prev.submissionTypes.filter(t => t !== typeId)
        : [...prev.submissionTypes, typeId]
    }));
  };
  const handleFileUpload = async (file: File) => {
  // const file = event.target.files ? event.target.files[0] : null;

  if (!file) {
    message.error('No file selected.');
    return;
  }

  if (file.size > formData.maxFileSize * 1024 * 1024) {
    message.error(`File size must be less than ${formData.maxFileSize} MB.`);
    return;
  }

  setIsUploading(true);

  try {
    const downloadURL = await uploadFileToFirebase(file);
    if (downloadURL) {
     setFormData(prev => ({
  ...prev,
  attachments: { name: file.name, url: downloadURL }
}));

      message.success(`${file.name} uploaded successfully.`);
    }
  } catch (err) {
    console.error('Upload failed:', err);
    message.error('Failed to upload file. Please try again.');
  } finally {
    setIsUploading(false);
  }
};


    const uploadFileToFirebase = async (file: File): Promise<string | null> => {
  const storage = getStorage();
  const filePath = `assignments/${subjectId}/${formData.moduleId}/${file.name}`;
  const fileRef = ref(storage, filePath);

  const snapshot = await uploadBytes(fileRef, file, {
    contentType: file.type
  });

  const downloadURL = await getDownloadURL(snapshot.ref);
  return downloadURL;
};



  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Create Assignment" size="lg">
      <form onSubmit={handleSubmit} className="space-y-6">
        {/* Title */}
        <div>
          <label htmlFor="title" className="block text-sm font-medium text-gray-700 mb-2">
            Assignment Title *
          </label>
          <input
            type="text"
            id="title"
            value={formData.title}
            onChange={(e) => setFormData(prev => ({ ...prev, title: e.target.value }))}
            className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 ${
              errors.title ? 'border-red-500' : 'border-gray-300'
            }`}
            placeholder="Enter assignment title"
          />
          {errors.title && <p className="mt-1 text-sm text-red-600">{errors.title}</p>}
        </div>



        {/* module */}
         <div>
  <label htmlFor="module" className="block text-sm font-medium text-gray-700 mb-2">
    Module *
  </label>

  <select
    id="module"
    value={formData.moduleId}
   onChange={(e) => {
  setFormData(prev => ({ ...prev, moduleId: e.target.value }));
  setModuleId(e.target.value);
}}

    className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 ${
      errors.module ? 'border-red-500' : 'border-gray-300'
    }`}
  >
    <option value="">Select a module</option>
    {modules?.map((mod) => (
      <option key={mod._id} value={mod._id}>
        {mod.fullModuleName}
      </option>
    ))}
  </select>

  {errors.module && <p className="mt-1 text-sm text-red-600">{errors.module}</p>}
</div>




{/* Category Selection */}
<div>
  <label className="block text-sm font-medium text-gray-700 mb-2">Assignment Category *</label>
  <select
    value={formData.category || ''}
    onChange={(e) =>
      setFormData((prev) => ({
        ...prev,
        category: e.target.value,
        groupIds: [],
        individualIds: [],
      }))
    }
    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
  >
    <option value="">Select category</option>
    <option value="all">All</option>
    <option value="group">Group</option>
    <option value="individual">Individual</option>
  </select>
</div>

{/* Group Selection */}
{formData.category === 'group' && (
  <div>
    <label className="block text-sm font-medium text-gray-700 mb-2">Select Groups *</label>
    {groupName.map((group) => (
      <div key={group}>
        <label className="inline-flex items-center space-x-2">
          <input
            type="checkbox"
            value={group}
            checked={formData.groups?.includes(group)}
            onChange={(e) => {
              setFormData((prev) => {
                const current = prev.groups || [];
                const updated = e.target.checked
                  ? [...current, group] // Add
                  : current.filter((g) => g !== group); // Remove

                return {
                  ...prev,
                  groupNames: updated,
                };
              });
            }}
          />
          <span>{group}</span>
        </label>
      </div>
    ))}
  </div>
)}


{/* Individual Selection */}
{formData.category === 'individual' && (
  <div>
    <label className="block text-sm font-medium text-gray-700 mb-2">Select Students *</label>
    <select
      multiple
      value={formData.individualIds || []}
      onChange={(e) =>
        setFormData((prev) => ({
          ...prev,
          individualIds: Array.from(e.target.selectedOptions, (opt) => opt.value),
        }))
      }
      className="w-full px-3 py-2 border border-gray-300 rounded-md h-28 focus:outline-none focus:ring-2 focus:ring-blue-500"
    >
      {studentId.map((student) => (
        <option key={student.id} value={student.id}>
          {student.name}
        </option>
      ))}
    </select>
  </div>
)}



        {/* Description */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Description *
          </label>
          <RichTextEditor
            value={formData.description}
            onChange={(value) => setFormData(prev => ({ ...prev, description: value }))}
            placeholder="Enter assignment description and instructions..."
          />
          {errors.description && <p className="mt-1 text-sm text-red-600">{errors.description}</p>}
        </div>

        {/* File Attachments */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Assignment Files
          </label>
          <FileUpload
  onFilesSelected={async (files: File[]) => {
    const file = files[0];
   
   handleFileUpload(file);
  }}
  label="Upload assignment materials"
/>

        </div>

        {/* Submission Types */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Accepted Submission Types *
          </label>
          <div className="grid grid-cols-2 gap-3">
            {submissionTypeOptions.map((option) => (
              <label key={option.id} className="flex items-center space-x-3 cursor-pointer">
                <input
                  type="checkbox"
                  checked={formData.submissionTypes.includes(option.id)}
                  onChange={() => handleSubmissionTypeChange(option.id)}
                  className="w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                />
                <span className="text-lg">{option.icon}</span>
                <span className="text-sm text-gray-700">{option.label}</span>
              </label>
            ))}
          </div>
          {errors.submissionTypes && <p className="mt-1 text-sm text-red-600">{errors.submissionTypes}</p>}
        </div>

        {/* File Size Limit */}
        <div>
          <label htmlFor="maxFileSize" className="block text-sm font-medium text-gray-700 mb-2">
            Maximum File Size (MB)
          </label>
          <input
            type="number"
            id="maxFileSize"
            min="1"
            max="100"
            value={formData.maxFileSize}
            onChange={(e) => setFormData(prev => ({ ...prev, maxFileSize: parseInt(e.target.value) }))}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>

        {/* Dates */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label htmlFor="dueDate" className="block text-sm font-medium text-gray-700 mb-2">
              📅 Due Date *
            </label>
            <input
              type="datetime-local"
              id="dueDate"
              value={formData.dueDate}
              onChange={(e) => setFormData(prev => ({ ...prev, dueDate: e.target.value }))}
              className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 ${
                errors.dueDate ? 'border-red-500' : 'border-gray-300'
              }`}
            />
            {errors.dueDate && <p className="mt-1 text-sm text-red-600">{errors.dueDate}</p>}
          </div>

          <div>
            <label htmlFor="cutoffDate" className="block text-sm font-medium text-gray-700 mb-2">
              📅 Cut-off Date *
            </label>
            <input
              type="datetime-local"
              id="cutoffDate"
              value={formData.cutoffDate}
              onChange={(e) => setFormData(prev => ({ ...prev, cutoffDate: e.target.value }))}
              className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 ${
                errors.cutoffDate ? 'border-red-500' : 'border-gray-300'
              }`}
            />
            {errors.cutoffDate && <p className="mt-1 text-sm text-red-600">{errors.cutoffDate}</p>}
          </div>
        </div>

        {/* Maximum Marks */}
        <div>
          <label htmlFor="maxMarks" className="block text-sm font-medium text-gray-700 mb-2">
            Maximum Marks
          </label>
          <input
            type="number"
            id="maxMarks"
            min="1"
            value={formData.maxMarks}
            onChange={(e) => setFormData(prev => ({ ...prev, maxMarks: parseInt(e.target.value) }))}
            className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 ${
              errors.maxMarks ? 'border-red-500' : 'border-gray-300'
            }`}
          />
          {errors.maxMarks && <p className="mt-1 text-sm text-red-600">{errors.maxMarks}</p>}
        </div>

        {/* Form Actions */}
        <div className="flex justify-end space-x-4 pt-4 border-t border-gray-200">
          <Button variant="secondary" onClick={onClose}>
            Cancel
          </Button>
          <Button type="submit" disabled={isSubmitting}>
            {isSubmitting ? (
              <span className="flex items-center">
                <div className="animate-spin w-4 h-4 border-2 border-white border-t-transparent rounded-full mr-2"></div>
                Creating...
              </span>
            ) : (
              'Create Assignment'
            )}
          </Button>
        </div>
      </form>
    </Modal>
  );
};

export default DemoAssignmentModal;
